import React, { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import { Box, Typography, Button } from "@mui/material";
const DeleteQuestionModal = ({ open,onClose,onConfirmDelete }) =>{

    const handleDelete = () => {
    onConfirmDelete();
    onClose();
  };
  
return(
<Modal
open={open}
onClose={onClose}
aria-labelledby="youtube-modal-title"
      // Apply the style to the modal container
      className="flex place-content-center items-center fixed"
      // Disable clicking on the backdrop and Escape key
      BackdropProps={{
        style: { pointerEvents: "none" },
      }}
      disableEscapeKeyDown
>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 500,
          bgcolor: 'background.paper',
          border: '2px solid #000',
          boxShadow: 24,
          p: 4,
          borderRadius: '5px',
        }}
      >
        <Typography id="delete-modal-title" variant="h6" component="h2" sx={{ mb: 2 }}>
          Delete Question
        </Typography>
        
        {/* <Typography sx={{ mb: 3 }}>
          Are you sure you want to delete question {questionNumber}? This action cannot be undone.
        </Typography> */}
        <Typography sx={{ mb: 3 }}>
          Are you sure you want to delete this question? This action cannot be undone.
        </Typography>
        
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
          <Button 
            variant="outlined" 
            onClick={onClose}
            sx={{ 
              color: '#6b7280',
              borderColor: '#d1d5db',
              '&:hover': {
                borderColor: '#9ca3af',
                backgroundColor: '#f9fafb'
              }
            }}
          >
            Cancel
          </Button>
          <Button 
            variant="contained" 
            onClick={handleDelete}
            sx={{ 
              backgroundColor: '#ef4444',
              '&:hover': {
                backgroundColor: '#dc2626'
              }
            }}
          >
            Delete
          </Button>
        </Box>
      </Box>
</Modal>
)
}

export default DeleteQuestionModal;